import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VCharts from 'v-charts'
import VueMomentLib from "vue-moment-lib"
import Viewer from 'v-viewer'

import Print from 'vue-print-nb'
Vue.use(Print)

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import './assets/style/common.css'
import './assets/style/main.css'
import './assets/style/theme/index.css'
import './assets/style/mobile.css'

import 'viewerjs/dist/viewer.css'
Vue.use(Viewer, {
  defaultOptions: {
    "title": false,
    "url": "data-src",
    "zIndex": 9999
  }
})


import { uploadLimitSize } from './config/env'
Vue.prototype.uploadLimitSize = uploadLimitSize

// 自定义组件
import StatusTag from '@/components/status_tag'
import CustomerLink from '@/components/customer_link'
import QuotationLink from '@/components/quotation_link'
import OrderLink from '@/components/order_link'
import PurchaseLink from '@/components/purchase_link'
import FileButton from '@/components/file_button'
import DealerLink from '@/components/dealer_link'
import ServiceQuestLink from '@/components/service_quest_link'
import CustomerRankSelect from '@/components/select/customer_rank_select'
Vue.component('CustomerRankSelect', CustomerRankSelect)

import CustomTip from '@/components/CustomTip'
Vue.component('CustomTip', CustomTip)

import MaintainanceAmount from '@/components/MaintainanceAmount'
Vue.component('MaintainanceAmount', MaintainanceAmount)

import CustomConfig from '@/components/CustomConfig'
Vue.component('CustomConfig', CustomConfig)

import CustomerSelector from '@/components/select/CustomerSelector'
Vue.component('CustomerSelector', CustomerSelector)

import BusinessOpportunitySelector from '@/components/select/BusinessOpportunitySelector'
Vue.component('BusinessOpportunitySelector', BusinessOpportunitySelector)

Vue.use(StatusTag)
Vue.use(CustomerLink)
Vue.use(QuotationLink)
Vue.use(OrderLink)
Vue.use(PurchaseLink)
Vue.use(FileButton)
Vue.use(DealerLink)
Vue.use(ServiceQuestLink)

Vue.use(ElementUI);
Vue.use(VCharts);
Vue.use(VueMomentLib)

Vue.config.productionTip = false

import './permission' // permission control

import util from './util/index';
Vue.use(util)

import AuthImg from '@/components/AuthImg'
Vue.component('AuthImg', AuthImg)

import authCode from '@/util/auth_code' //权限码获取
Vue.prototype.Auth = authCode

import permission from '@/directive/permission' //权限判断
Vue.directive('permission', permission)

new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')
